module.exports = __webpack_public_path__ + "banner.108c7a8eb68394fed0c6.jpg";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/images/banner.jpg
// module id = ../../../../../src/assets/images/banner.jpg
// module chunks = main